import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-form',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment-form.component.html',
  styleUrl: './payment-form.component.scss'
})
export class PaymentFormComponent {
  @ViewChild('wompiForm') wompiForm: ElementRef<HTMLFormElement>;
  
  publicKey: string = environment.wompi.publicKey;
  currency: string = environment.wompi.currency;
  urlRedirect: string = environment.urlSitePacientes;
  @Input() amountInCents: number = 0;
  @Input() reference: string = '';
  @Input() signature: string = '';

  /**
   * submitPayment()
   */
  submitPayment() {
    this.setFormValues();
    this.wompiForm.nativeElement.submit();
  }

  /**
   * 
   */
  setFormValues() {    
    const form = this.wompiForm.nativeElement;
    (form.querySelector('input[name="currency"]') as HTMLInputElement).value = this.currency;
    (form.querySelector('input[name="amount-in-cents"]') as HTMLInputElement).value = (this.amountInCents * 100).toString();
    (form.querySelector('input[name="reference"]') as HTMLInputElement).value = this.reference.toString();
    (form.querySelector('input[name="signature:integrity"]') as HTMLInputElement).value = this.signature.toString();
  }

}
